import { useForm } from "react-hook-form";
import CustomInput from "../../components/CustomInput/CustomInput";
import regexList from "../../utils/regexList";
import { useNavigate } from "react-router-dom";
import { signup } from "../../endpoints/auth.service";
import { useSnackbar } from "notistack";
import TickOutline from "../../assets/svg/TickOutline";
import LoadingAnimation from "../../assets/svg/LoadingAnimation";
import { useState } from "react";
import { userTypes } from "../../utils/constants";
import Footer from "../../components/footer/footer";

const HiringCompanyRegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      isLoading: false,
      keepMeSignedIn: false,
    },
  });
  const [keepMeSignedIn, setKeepMeSignedIn] = useState(false);

  const fields = watch();

  const handleRegister = async (fields) => {
    try {
      setValue("isLoading", true);
      const { data, success } = await signup({
        ...fields,
        userType: userTypes.HIRING_COMPANY,
      });

      if (success) {
        localStorage.setItem("accessToken", data.token);
        if (!data?.verifiedEmail) {
          navigate(`/email-verification`, {
            state: {
              email: fields?.email,
            },
          });
        }
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setValue("isLoading", false);
    }
  };

  return (
    <div className="h-full w-full flex-1 justify-center flex flex-col overflow-scroll no-scrollbar">
      {/* Form Container */}
      <div className="flex-1 flex justify-center relative">
        <div className="z-10 mb-[5%] mt-[350px] flex flex-col justify-center items-center border-[#DDDDDD] border rounded-lg py-10 px-16 bg-white relative h-max self-center w-full lg:w-[28%] md:min-w-[500px]">
          <div className="mb-10 flex flex-col items-center">
            <p className="font-bold text-2xl">Hiring company register</p>
            <p className="font-medium text-xss">
              By signing up, you’ll be the first to get access to our smart
              recruitment tools!
            </p>
          </div>

          <form
            className="flex flex-col w-full"
            onSubmit={handleSubmit(handleRegister)}
          >
            <div className="flex flex-col gap-4">
              <div className="flex items-center justify-center gap-3">
                {/* @ts-ignore */}
                <CustomInput
                  label={"First Name"}
                  placeholder={"Enter your First Name"}
                  name="firstName"
                  rules={{
                    required: "This field is required.",
                  }}
                  control={control}
                  errors={errors}
                />
                {/* @ts-ignore */}
                <CustomInput
                  label={"Last Name"}
                  placeholder={"Enter your Last Name"}
                  name="lastName"
                  rules={{
                    required: "This field is required.",
                  }}
                  control={control}
                  errors={errors}
                />
              </div>
              {/* @ts-ignore */}
              <CustomInput
                label={"Company Name"}
                placeholder={"Enter your Company Name"}
                name="companyName"
                rules={{
                  required: "This field is required.",
                }}
                control={control}
                errors={errors}
              />
              {/* @ts-ignore */}
              <CustomInput
                label={"Email"}
                placeholder={"Enter your Email"}
                name="email"
                rules={{
                  required: "This field is required.",
                  pattern: {
                    value: regexList.email,
                    message: "Please enter a valid email.",
                  },
                }}
                control={control}
                errors={errors}
              />
              {/* @ts-ignore */}
              <CustomInput
                label={"Password"}
                placeholder={"Enter your Password"}
                name="password"
                rules={{
                  required: "This field is required.",
                  pattern: {
                    value: regexList.password,
                    message: "Please enter a valid password.",
                  },
                }}
                control={control}
                errors={errors}
              />
              {/* @ts-ignore */}
              <CustomInput
                label={"Confirm Password"}
                placeholder={"Enter your Password"}
                name="confirmPassword"
                rules={{
                  required: "This field is required.",
                  pattern: {
                    value: regexList.password,
                    message: "Please enter a valid password.",
                  },
                }}
                control={control}
                errors={errors}
              />
            </div>

            <div className="flex items-center gap-2 mt-2">
              <div
                onClick={() => setKeepMeSignedIn((prev) => !prev)}
                className="border-2 border-[#6F6F6F] h-4 w-4 flex items-center justify-center cursor-pointer"
              >
                {keepMeSignedIn ? (
                  <TickOutline className="w-1.5 h-1.5" fill="#6F6F6F" />
                ) : null}
              </div>
              <span
                role="button"
                className="font-montserrat font-medium text-primary text-sm"
              >
                I agree to the{" "}
                <span className="underline">Terms and Conditions</span>
              </span>
            </div>

            <button
              type="submit"
              className="bg-[#6F6F6F] flex items-center justify-center rounded mt-10 self-end py-[10px] px-6"
            >
              {fields?.isLoading && <LoadingAnimation />}
              <span className="text-white font-medium">Register</span>
            </button>
            <span className="mx-auto text-sm mt-1 mt-3 font-medium text-light-black">
              Already have an account?{" "}
              <span
                onClick={() => navigate(-1)}
                className="text-[#03A9F4] cursor-pointer"
              >
                Login
              </span>
            </span>
          </form>
        </div>
        <div className="bg-slate-100 h-[45%] absolute w-full" />
      </div>
      <Footer />
    </div>
  );
};

export default HiringCompanyRegisterPage;
